import { createSlice } from "@reduxjs/toolkit";
import {
  postSummary,
  getSummaryStatus,
  getSummaryList,
  getSummaryTypes,
  getSummaryKPI
} from "../services/summarization.service";

const initialState = {
  summarizeLoader: false,
  // summarizeSuccessMsg: "",
  summarizeErrorMsg: "",
  summaryResId: null,
  listSummaryData: [],
  totalRecordCount: 0,
  total_pages: 0,
  summaryStatusApiStopMsg: "",
  // summary types
  summaryTypesData: [],
  summaryTypesLoader: false,
  kpiValues: []
};

const kpiData = [
  {
    statusPercentage: 60,
    status: "Completed",
    colors: ["#86C653", "#E7F1DB"],
  },
  {
    statusPercentage: 15,
    status: "Started",
    colors: ["#2772F0", "#DEE8F8"],
  },
  {
    statusPercentage: 10,
    status: "In Queue",
    colors: ["#F5E064","#FFF7C7"],
  },
  {
    statusPercentage: 10,
    status: "Pending",
    colors: ["#FF9D0E", "#FDE4C0"],
  },
  {
    statusPercentage: 5,
    status: "Failed",
    colors: ["#FF5B5B", "#FCE1E1"],
  },
];

const formatKPI = (kpi:any) => {
  let series:any = [];
  kpi.forEach((ele:any) => {
    let color = kpiData.find(kpi => kpi.status == ele.status)?.colors;
    let temp = {
      statusPercentage: ele.percentage,
      status: ele.status,
      colors: color ? color : ["#2772F0", "#DEE8F8"]
    }
    series.push(temp);
  });
  
  return series;
}

const SummarizationSlice = createSlice({
  name: "summarize",
  initialState: initialState,
  reducers: {
    ResetSummarizeValue: (state, action) => {
      state.listSummaryData = [];
      state.summaryStatusApiStopMsg = "";
      state.totalRecordCount = 0;
      state.total_pages = 0;
    },
    setApiStopMsg: (state, action) => {
      state.summarizeLoader = false;
      state.summaryStatusApiStopMsg = action.payload;
    },
    setChartKPI: (state, action) => {
      state.kpiValues = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(postSummary.pending, (state, action) => {
        state.summarizeLoader = true;
      })
      .addCase(postSummary.fulfilled, (state, action: any) => {
        if (action.payload) {
          state.summaryResId = action.payload?.data?.summary_id;
        } else {
          state.summarizeLoader = false;
        }
      })
      .addCase(postSummary.rejected, (state, action) => {
        state.summarizeLoader = false;
        state.summarizeErrorMsg = "Error in add summary";
      })
      .addCase(getSummaryStatus.pending, (state, action) => {
        state.summarizeLoader = true;
      })
      .addCase(getSummaryStatus.fulfilled, (state, action: any) => {
        state.summarizeLoader = true;
        if (action.payload && action.payload?.data?.results) {
          if (
            action.payload?.data.results[0].summary ||
            (!action.payload?.data.results[0].summary &&
              (action.payload?.data.results[0].status === "failed" ||
                action.payload?.data.results[0].status === "completed"))
          ) {
            state.summarizeLoader = false;
          }
        }
      })
      .addCase(getSummaryStatus.rejected, (state, action: any) => {
        state.summarizeLoader = false;
        state.summarizeErrorMsg = action.error.message;
      })
      .addCase(getSummaryList.pending, (state, action) => {
        state.summarizeLoader = true;
      })
      .addCase(getSummaryList.fulfilled, (state, action: any) => {
        state.summarizeLoader = false;
        if (action.payload && action.payload?.data) {
          // state.summarizeSuccessMsg= action.payload?.message;
          state.listSummaryData = action.payload?.data?.results;
          state.totalRecordCount = action.payload?.data?.count;
          state.total_pages = action.payload?.data?.total_pages;
        }
      }) 
      .addCase(getSummaryList.rejected, (state, action: any) => {
        state.summaryTypesLoader = false;
        // state.summarizeErrorMsg = action.error.message? action.error.message: "Summarization listing api error";
      })     
      .addCase(getSummaryTypes.pending, (state) => {
        state.summaryTypesLoader = true;
      })      
      .addCase(getSummaryTypes.fulfilled, (state, action: any) => { 
        if (action.payload && action.payload?.data) {
          state.summaryTypesLoader = false;
       //   state.summarizeErrorMsg = "";
       state.summaryTypesData = action.payload.data?.results;
        }
      })
      .addCase(getSummaryTypes.rejected, (state, action: any) => {
        state.summaryTypesLoader = false;
       // state.summarizeErrorMsg = action.error.message;
      })
      .addCase(getSummaryKPI.fulfilled, (state,action:any) => {
        // console.log(formatKPI(action.payload.data));
        state.kpiValues =  formatKPI(action.payload.data);;
        // console.log(state.kpiValues);
      })
      .addCase(getSummaryKPI.rejected,(state:any,action:any) => {
        state.kpiValues = [];
      })
  },
});

export const { ResetSummarizeValue, setApiStopMsg,setChartKPI } =
  SummarizationSlice.actions;
export default SummarizationSlice.reducer;
